import Subject from "../cse4sub/Subject";
import React from 'react'
import cse from '../assets/ECE306end21.pdf'
import csm from '../assets/ECE306mid21.pdf'


export default function Nt() {
  return (
    <div>
       <Subject title="Network Theory(ECE306)"mid="Q. Paper"
    book1=" " book2=" "
    book1Link="#" book2Link="#" int21="#" mid21={csm} end21={cse}
     int20="#" mid20="#" end20="#"
    />
    </div>
  )
}